import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';

import { PendingTransaction } from '@/types/api/bankid/v2/transaction';
import { getTransactionQueryOptions } from './get-transaction';

export const startTransaction = async (): Promise<PendingTransaction> => {
  return (await api.post(`/bankid/start`)).data;
};

type UseStartTransactionOptions = {
  mutationConfig?: MutationConfig<typeof startTransaction>;
};

export const useStartTransaction = ({ mutationConfig }: UseStartTransactionOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      queryClient.setQueryData(getTransactionQueryOptions(data.id).queryKey, data);
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: startTransaction,
  });
};
